import React, { useEffect, useState, useRef } from "react";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DexterCall from "../../Images/UpdatedDexter-call.svg";
import { useNavigate } from "react-router-dom";
import { isAfter, isBefore, isSameDay, isValid, parse } from "date-fns";
import { ToastContainer } from "react-toastify";
import Toast from "../../Components/ToastMsg/Toast";
import { useSelector } from "react-redux";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectPanNumber } from "../../Store/panNumberSlice";
import axios from "../../libs/axiosConfig";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../../style/Calender.css";

import {
  ROUTE_PLACEOF_BIRTH,
  ROUTE_EMAIL,
  ROUTE_ACCOUNT_TYPE,
  Address_Verification,
  ROUTE_CHECKBOXES,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_DXTER_SCANNING, ROUTE_NRI_Address
} from "../../Routes";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import LogoutModal from "../../Components/LogoutModal";

const GenderDob = () => {
  const [DOB, setDOB] = useState("");
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const [formErrors, setFormErrors] = useState({});
  const Navigate = useNavigate();
  const [isValidDob, setIsValidDob] = useState(true);
  const [nomineeAge, setNomineeAge] = useState(0);
  const [Gender, setGender] = useState("M");
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const refreshToken = useSelector(selectRefreshToken);
  const [occupation, setoccupation] = useState("Male");
  const [suggestionsOccupation, setSuggestionsOccupation] = useState([]);
  const [showSuggestionsOccupation, setShowSuggestionsOccupation] =
    useState(false);
  const dropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("Mr.");
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [apiCallsInProgress, setApiCallsInProgress] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  const handleClick = () => {
    setShowCalendar(!showCalendar);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowSuggestionsOccupation(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDateChange = (date) => {
    const currentDate = new Date();
    const minDate = parse("1925-01-01", "yyyy-MM-dd", new Date());
    const maxDate = currentDate;

    if (isValid(date) && !isAfter(date, maxDate)) {
      setSelectedDate(date);
      setShowCalendar(false);

      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
      setDOB(formattedDate);
      console.log(formattedDate);
    } else {
      console.error("Selected date is out of range");
    }
  };

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const occupations = ["Male", "Female"];
  const occupationscode = {
    Male: "M",
    Female: "F",
  };
  const handleoccupationChange = (e) => {
    const input = e.target.value;
    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setoccupation(input);

      const filteredSuggestions = occupations.filter(
        (item) =>
          item.toLowerCase().startsWith(input.toLowerCase()) &&
          item.toLowerCase() !== input.toLowerCase()
      );

      setSuggestionsOccupation(filteredSuggestions);
      setShowSuggestionsOccupation(true);
    }
  };
  const handleoccupationShow = () => {
    if (!showSuggestionsOccupation) {
      let filteredSuggestions = [];
      if (occupation.toLowerCase() === "male") {
        filteredSuggestions = occupations.filter(
          (item) => item.toLowerCase() === "female"
        );
      } else if (occupation.toLowerCase() === "female") {
        filteredSuggestions = occupations.filter(
          (item) => item.toLowerCase() === "male"
        );
      } else {
        filteredSuggestions = occupations.filter(
          (item) =>
            item.toLowerCase().startsWith(occupation.toLowerCase()) &&
            item.toLowerCase() !== occupation.toLowerCase()
        );
      }

      setSuggestionsOccupation(filteredSuggestions);
    }
    setShowSuggestionsOccupation((prevShowSuggestions) => !prevShowSuggestions);
  };

  const handleSuggestionClick = (selectedOccupation) => {
    setoccupation(selectedOccupation);
    setSuggestionsOccupation([]);
    setShowSuggestionsOccupation(false);

    let selectedGender = selectedOccupation === "Male" ? "M" : "F";
    setGender(selectedGender);

    let newTitle = selectedGender === "M" ? "Mr." : "Ms.";
    setTitle(newTitle);

    console.log("Title:", newTitle);

    console.log(
      "Selected Occupation Code:",
      occupationscode[selectedOccupation]
    );
  };

  const validateDob = (dob) => {
    const parsedDob = parse(dob, "dd-MM-yyyy", new Date());
    const currentDate = new Date();
    const isDateValid =
      isValid(parsedDob) &&
      isBefore(parsedDob, currentDate) &&
      !isSameDay(parsedDob, currentDate);
    const isDayValid = parsedDob.getDate() <= 31;
    const isMonthValid = parsedDob.getMonth() + 1 <= 12;
    const isYearValid = parsedDob.getFullYear() <= currentDate.getFullYear();
    return isDateValid && isDayValid && isMonthValid && isYearValid;
  };

  const handlenomineeDobChange = (e) => {
    let input = e.target.value.replace(/\D/g, "");
    let formattedInput = input
      .replace(/^(\d{2})(\d{0,2})/, "$1-$2")
      .replace(/^(\d{2})-(\d{2})(\d{0,4})/, "$1-$2-$3");

    if (formattedInput.length > 0) {
      const yearPart = formattedInput.split("-")[2];
      if (yearPart && yearPart.length > 4) {
        formattedInput = formattedInput.slice(0, -1);
      }
    }

    const [day, month, year] = formattedInput.split("-").map(Number);

    if (day > 31) {
      formattedInput = formattedInput.slice(0, -1);
    }

    if (month > 12) {
      formattedInput = formattedInput.slice(0, -1);
    }

    const currentYear = new Date().getFullYear();

    if (year < 1925 || year > currentYear) {
      setFormErrors({ DOB: "Please enter a valid date" });
    } else {
      setFormErrors({ DOB: "" });
    }

    if (
      year > currentYear ||
      (year === currentYear && month > new Date().getMonth() + 1) ||
      (year === currentYear &&
        month === new Date().getMonth() + 1 &&
        day > new Date().getDate())
    ) {
      const currentDate = new Date();
      formattedInput = `${currentDate.getDate().toString().padStart(2, "0")}-${(
        currentDate.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${currentDate.getFullYear()}`;
    }

    setDOB(formattedInput);
    setIsValidDob(validateDob(formattedInput));

    const parsedDob = parse(formattedInput, "dd-MM-yyyy", new Date());
    const currentDate = new Date();
    let age = currentDate.getFullYear() - parsedDob.getFullYear();

    if (
      currentDate.getMonth() < parsedDob.getMonth() ||
      (currentDate.getMonth() === parsedDob.getMonth() &&
        currentDate.getDate() < parsedDob.getDate())
    ) {
      age--;
    }
    setNomineeAge(age);
  };

  const handleSubmit = async () => {
    setApiCallsInProgress(apiCallsInProgress + 1);

    if (DOB && Gender) {
      // Toast.success("Form submitted successfully");
      // Navigate(Address_Verification);
    } else {
      Toast.error("Please fill all the details");
      setApiCallsInProgress(apiCallsInProgress - 1);
    }
    const parsedDate = parse(DOB, "dd-MM-yyyy", new Date());
    if (parsedDate.getFullYear() < 1925) {
      Toast.error("Please fill the valid date.");
      setApiCallsInProgress(apiCallsInProgress - 1);
      return;
    }
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      const dobFormatted = DOB.split("-").reverse().join("-");

      // Make a POST request to the first API endpoint
      const firstapi =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
      const requestBody = {
        CustomerKycDetails: {
          request_type: "post",
          mobileNumber: phoneNumber,
          pan: panNumber,
          gender: occupationscode[occupation],
          dob: dobFormatted,
          title: title,
        },
      };

      const response = await axios.post(firstapi, requestBody, { headers });
      console.log("First API Response:", response.data);

      // If the first API call is successful, make a second POST request to the second API endpoint
      // const secondapi =
      //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails";
      // const secondRequestBody = {
      //   gender: occupationscode[occupation],
      //   dob: dobFormatted,
      //   title: title,
      // };

      // const secondResponse = await axios.post(secondapi, secondRequestBody, {
      //   headers,
      // });
      // console.log("Second API Response:", secondResponse.data);

      // If the second API call is successful, make a third POST request to the third API endpoint
      if (firstapi.status === 200) {
        const thirdapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const thirdRequestBody = {
          CustomerKycDetails: {
            request_type: "get",
            mobileNumber: phoneNumber,
            pan: panNumber,
          },
        };
        setApiCallsInProgress(apiCallsInProgress - 1);

        const thirdResponse = await axios.post(thirdapi, thirdRequestBody, {
          headers,
        });
        // const customerKycApiResponse = await axios.get(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );

        if (
          thirdResponse.data.statusCode === 200 &&
          thirdResponse.data.status === true
        ) {
          setApiCallsInProgress(apiCallsInProgress - 1);

          if (thirdResponse.data.body.emailId === "") {
            Navigate(ROUTE_EMAIL);
          } else if (
            thirdResponse.data.body.bankAccountNumber === "" ||
            thirdResponse.data.body.bankIfscCode === "" ||
            thirdResponse.data.body.bankAccountType === "" ||
            thirdResponse.data.body.bankName === "" ||
            thirdResponse.data.body.bankBranchName === "" ||
            thirdResponse.data.body.bankBranchAddress === "" ||
            thirdResponse.data.body.bankCodeNSE === "" ||
            thirdResponse.data.body.bankCodeBillDesk === "" ||
            thirdResponse.data.body.bankAccountHolderName === ""
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            (thirdResponse.data.body.bankAccountNumber !== "" ||
              thirdResponse.data.body.bankIfscCode !== "" ||
              thirdResponse.data.body.bankAccountType !== "" ||
              thirdResponse.data.body.bankName !== "" ||
              thirdResponse.data.body.bankBranchName !== "" ||
              thirdResponse.data.body.bankBranchAddress !== "" ||
              thirdResponse.data.body.bankCodeNSE !== "" ||
              thirdResponse.data.body.bankCodeBillDesk !== "" ||
              thirdResponse.data.body.bankAccountHolderName !== "" ||
              null) &&
            (thirdResponse.data.body.bankVerified.account_exists !== "True" ||
              thirdResponse.data.body.bankVerified.message !== "success")
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            thirdResponse.data.body.panDetails.addr1 === "" ||
            thirdResponse.data.body.panDetails.addr2 === "" ||
            thirdResponse.data.body.panDetails.city === "" ||
            thirdResponse.data.body.panDetails.state === "" ||
            thirdResponse.data.body.panDetails.pincode === "" ||
            thirdResponse.data.body.panDetails.country === "" ||
            thirdResponse.data.body.panDetails.fullAddress === ""
          ) {
            Navigate(Address_Verification);
          } else if (
            thirdResponse.data.body.placeOfBirth === "" ||
            thirdResponse.data.body.nseCountryCodeOfBirth === "" ||
            thirdResponse.data.body.nseCountryOfBirth === ""
          ) {
            Navigate(ROUTE_PLACEOF_BIRTH);
          } else if (
            thirdResponse.data.body.politicallyExposedPerson === "" ||
            null ||
            thirdResponse.data.body.relatedToPoliticallyExposedPerson === ""
          ) {
            Navigate(ROUTE_CHECKBOXES);
          } else if (
            thirdResponse.data.body.nomineeName !== "" ||
            thirdResponse.data.body.nomineeType !== "" ||
            thirdResponse.data.body.nomineeRelationShip !== "" ||
            (thirdResponse.data.body.nomineeDob !== "" &&
              thirdResponse.data.body.nomineeVerified === "N")
          ) {
            console.log("first");
            Navigate(ROUTE_NOMINEE_SENDOTP);
          }
          const requestBody = {
            dexterrCustomerBasicQuestions: {
              mobile_no: phoneNumber,
              request_type: "get",
              country_code: "+91",
            }
          };
          const headers = {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken
          };

          const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
            headers: headers
          });
          if (secondApiResponse.data.data.resident !== "Resident Indian") {
            Navigate(ROUTE_NRI_Address)
          }


          else {
            Navigate(ROUTE_DXTER_SCANNING);
          }
        } else {
          Toast.error(
            thirdResponse.data.message + " " + thirdResponse.data.errorMessage
          );
        }
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  const handleBackspace = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    let formattedInput = "";

    if (input.length > 2) {
      formattedInput = input.slice(0, 2) + "-" + input.slice(2, 4);
      if (input.length > 4) {
        formattedInput += "-" + input.slice(4, 8);
      }
    } else {
      formattedInput = input;
    }

    setDOB(formattedInput);
  };

  return (
    <div className="Dob_Main_Container">
      <div className="Purchase_VrifyOtp_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="Gender_Date_Container">
        <p className="Input_Heading_text">Personal Details </p>
        {/* <span className={classes.Input_Sub_heading}>
          Korem ipsum dolor sit amet, consectetur
          adipiscing elit.
        </span> */}
        <div className="Input_Filed_Box">
          <span className="Enter_mobile_text">Date of Birth </span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.DOB ? classes.Error : ""
                }`}
              value={DOB}
              placeholder="DD-MM-YYYY"
              onChange={handlenomineeDobChange}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  handleBackspace(e);
                }
              }}
            />

            <CalendarMonthOutlinedIcon
              onClick={handleClick}
              className={classes.Calendar_Icon}
            />
          </div>
        </div>
        {showCalendar && (
          <div className={classes.Calendar_Container}>
            <Calendar
              onChange={handleDateChange}
              value={selectedDate}
              className="custom-calendar-style"
              maxDate={new Date()}
            />
          </div>
        )}
        {formErrors.DOB && (
          <span className={classes.Error_Message}>{formErrors.DOB}</span>
        )}

        {/* <p className={classes.Input_Heading_text}>Gender</p> */}

        <div className="Input_Filed_Box">
          <span className="Enter_mobile_text">Gender</span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.ifscCode ? classes.Error : ""
                }`}
              value={occupation}
              onChange={handleoccupationChange}
              onBlur={() => setShowSuggestionsOccupation(true)}
            />

            <button
              className={classes.DropDown_button}
              onClick={handleoccupationShow}
            />
          </div>
          {showSuggestionsOccupation && (
            <div
              className={classes.Suggestions_Container_DOB}
              ref={dropdownRef}
            >
              {suggestionsOccupation.map((suggestion, index) => (
                <div
                  key={index}
                  className={classes.Suggest_Suggestion_DOB}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </div>
              ))}
            </div>
          )}

          {/* <div className={classes.Input_Gender_Container}> */}
          {/* <select
              className={classes.Input_Filed}
              value={Gender}
              onChange={handleGenderChange}
            > */}

          {/* <option value="M" className={classes.Gender_Select}>
                Male
              </option>
              <option value="F" className={classes.Gender_Select}>
                Female
              </option> */}
          {/* </select> */}
          {/* </div> */}
        </div>
        <button className="Submit_button" onClick={handleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
      ;
    </div>
  );
};

export default GenderDob;
